import { get } from '@kit/utils/APIV1.js'

export const page = async({section, slug}) => {
  return get(`hta-page/section/${section}/slug/${slug}`)
}
